<template>
  <div class="w-100">
    <h5 class="text-center">Bills of Lading</h5>
    <div class="d-flex flex-column p-3">
      <div class="d-flex flex-row flex-wrap justify-content-end mb-2">
        <!-- Data Table -->
        <data-table-resultado-bill-lading
          :headers="headers"
          :data="data"
          :acciones="acciones"
          idtabla="bills_landing_tabla_resultado"
        />
      </div>
    </div>
  </div>
</template>

<script>
// Componentes;
import { mapActions, mapState } from "vuex";
import DataTableResultadoBillLading from "@/components/dataTables/buscador/DataTableResultadoBillLading.vue";

export default {
  data() {
    return {
      // Estructura para utilizar dataTable vue
      headers: [
        "ID",
        "Naviera",
        "Nave",
        "Viaje",
        "Número de Booking",
        "Cantidad de Contenedores",
        "Acciones"
      ],
      data: [],
      acciones: []
    };
  },
  components: {
    DataTableResultadoBillLading
  },
  computed: {
    ...mapState("lineas", [
      "dataResultadoBillLadings"
    ])
  },
  methods: {
    ...mapActions(["AccionCambiar", "ActionSetLoadingTable"]),
    async generarBotonesAcciones() {

      let me = this;

      me.acciones = [];

      await me.data.map((item, index) => {
        me.acciones.push([
          {
            icon: item.data_complementaria.path != null ? "fas fa-cloud-download-alt text-primary" : "fas fa-cloud-download-alt text-secondary",
            title: "Descargar BL",
            id: index
          }
        ]);
      });
    }
  },
  watch: {
    dataResultadoBillLadings: function(_new) {
      if (_new) {
        this.data = _new;
        this.generarBotonesAcciones();
      }
    }
  },
  created() {
    this.data = this.dataResultadoBillLadings;
    this.generarBotonesAcciones();
  }

};
</script>

<style>
.ui-modal--size-large > .ui-modal__wrapper > .ui-modal__container {
    width: 70rem;
}
</style>
